export default "__VITE_PUBLIC_ASSET__0c5c2933__"